import{get}from"@styled-system/core";/**
 * Taken from styled-system
 * Theme-UI have no plans to add this feature
 * https://github.com/system-ui/theme-ui/issues/431
 */var isNumber=function(a){return"number"==typeof a&&!Number.isNaN(a)},getWidth=function(a,b){return get(b,a,!isNumber(a)||1<a?a:"".concat(100*a,"%"))};export var getResponsiveWidths=function(a){var b=a;return a&&(isNumber(a)&&(b=getWidth(a)),Array.isArray(a)&&(b=a.map(function(a){return getWidth(a)}))),b};